import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Some environments/extensions inject a web-vitals performance observer that
// throws "Cannot read properties of undefined (reading 'startTime')" from an
// anonymous (eval'd) script. It's not from our code and is harmless, so we
// swallow just that specific error to keep the console clean and avoid tripping
// any error overlay. All other errors pass through unchanged.
// Matches the injected web-vitals crash regardless of the "Uncaught TypeError:"
// prefix and regardless of filename (eval'd/anonymous scripts often report '').
const isInjectedWebVitalsError = (msg, err) => {
  const text = (err && (err.message || String(err))) || (typeof msg === 'string' ? msg : '');
  const stack = (err && err.stack) || '';
  return text.includes("reading 'startTime'")
    || /reportAllChanges/.test(stack);
};

window.addEventListener('error', (e) => {
  if (isInjectedWebVitalsError(e.message, e.error)) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  if (isInjectedWebVitalsError('', e.reason)) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
